module.exports = __webpack_public_path__ + "static/media/business_hero.e59f95bf.jpg";